"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

var _constants = require("@insided/shared/constants");

var NavigationLogo = function NavigationLogo(_ref) {
  var customerName = _ref.customerName;
  return (0, _preact.h)("div", {
    className: "control-side-menu__menu-item-logo"
  }, (0, _preact.h)("img", {
    src: (0, _absoluteUrlRuntime.resolveUrl)("".concat((0, _globals.default)('basePath')).concat(_constants.PLATFORM_NAVIGATION_LOGO_PATH))
  }), (0, _preact.h)("div", {
    className: "control-side-menu__menu-item-label"
  }, (0, _preact.h)("span", null, "Proudly working for ", customerName, " \uD83D\uDC99")));
};

var _default = NavigationLogo;
exports.default = _default;